import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CrossoverService } from 'src/app/services/crossover.service';
import { HighchartsChartModule } from 'highcharts-angular';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CommonModule } from '@angular/common';
import { ListaPulsantiMercatiComponent } from '../../shared/lista-pulsanti-mercati/lista-pulsanti-mercati.component';

@Component({
  selector: 'app-ultimi-valori-h4',
  standalone: true,
  imports: [ReactiveFormsModule, HighchartsChartModule, MdbSelectModule, 
    CommonModule, ListaPulsantiMercatiComponent],
  templateUrl: './ultimi-valori-h4.component.html',
  styleUrl: './ultimi-valori-h4.component.scss'
})
export class UltimiValoriH4Component {

  dati: any = []
  datiTable: any = []
  datiTotali: any = []
  headers = ['ora', 'eur', 'usd', 'gbp', 'jpy', 'aud', 'nzd', 'cad', 'chf']
  mercati = ['eur', 'usd', 'gbp', 'jpy', 'aud', 'cad', 'chf', 'nzd'];
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}
  chartOptions2: Highcharts.Options = {}
  chartOptions3: Highcharts.Options = {}
  

  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  oraUltimoValore: string = ''

  mkt1: any = ['eur', 'usd', 'gbp', 'aud', 'cad', 'chf', 'nzd']
  mkt2: any = ['usd', 'gbp', 'jpy', 'aud', 'cad', 'chf', 'nzd']
  loading: boolean = false

  constructor(private serv: CrossoverService) { }


  ngOnInit(): void {
    this.serv.listH4().subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        this.datiTable = data.dati.slice(0, 10)
        this.dati = data.dati.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))
        this.datiTotali = data.dati//.sort((a: any, b: any) => a.ora - b.ora)
        this.aggiornaGrafico(this.dati)
      }
    })
  }

  aggiorna() {
    this.loading = true
    this.serv.aggiornaCrossH4().subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        this.serv.listH4().subscribe((data: any) => {
          console.log(data)
          if (data.res == 'ok') {
            this.datiTable = data.dati.slice(0, 10)
            this.dati = data.dati.sort((a: any, b: any) => (new Date(a.ora)).getTime() - (new Date(b.ora).getTime()))
            this.datiTotali = data.dati//.sort((a: any, b: any) => a.ora - b.ora)
            this.aggiornaGrafico(this.dati)
          }
        })
      }
      this.loading = false
    })
  }

  aggiornaGrafico(dati: any, numeroDato: number = 100) {
    let s1 = dati.map((el: any) => [el.ora, parseFloat(el.eur)])
    let s2 = dati.map((el: any) => [el.ora, parseFloat(el.usd)])
    let s3 = dati.map((el: any) => [el.ora, parseFloat(el.gbp)])
    let s4 = dati.map((el: any) => [el.ora, parseFloat(el.jpy)])
    let s5 = dati.map((el: any) => [el.ora, parseFloat(el.aud)])
    let s6 = dati.map((el: any) => [el.ora, parseFloat(el.nzd)])
    let s7 = dati.map((el: any) => [el.ora, parseFloat(el.cad)])
    let s8 = dati.map((el: any) => [el.ora, parseFloat(el.chf)])
    s1 = s1.splice(s1.length - numeroDato)
    s2 = s2.splice(s2.length - numeroDato)
    s3 = s3.splice(s3.length - numeroDato)
    s4 = s4.splice(s4.length - numeroDato)
    s5 = s5.splice(s5.length - numeroDato)
    s6 = s6.splice(s6.length - numeroDato)
    s7 = s7.splice(s7.length - numeroDato)
    s8 = s8.splice(s8.length - numeroDato)
    let ser: Highcharts.SeriesOptionsType[] = [
      { name: 'eur', type: 'line', data: s1 },
      { name: 'usd', type: 'line', data: s2 },
      { name: 'gbp', type: 'line', data: s3 },
      { name: 'jpy', type: 'line', data: s4 },
      { name: 'aud', type: 'line', data: s5 },
      { name: 'nzd', type: 'line', data: s6 },
      { name: 'cad', type: 'line', data: s7 },
      { name: 'chf', type: 'line', data: s8 },
    ]
    this.chartOptions = {
      title: {
        text: 'CrossOver H4'
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      yAxis: {
        plotLines: [{
          value: 0,
          width: 2,
          color: 'black',
          zIndex: 4
        }]
      },
      series: ser
    }
  }
  valoriGrafico(event: any){
    console.log(event.target.value)
    this.aggiornaGrafico(this.datiTotali, event.target.value)
  }

  mercatoSelezionato(mkt: any) {
    let mkt1 = mkt.market.substring(0, 3).toLowerCase()
    let mkt2 = mkt.market.substring(3, 7).toLowerCase()
    this.serv.valoriCambioH4(mkt1 + mkt2, this.datiTotali[0].ora).subscribe((data: any) => {
      if (data.res == 'ok') {
        console.log(data)
        let s1 = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt1])])
        let s2 = this.datiTotali.map((el: any) => [el.ora, parseFloat(el[mkt2])])
        let s3 = data.data.map((el: any) => [ el.ora, parseFloat(el.vclose)])
        let s1a = this.datiTotali.map((el: any) => [ el.ora, parseFloat(el[mkt1]) - parseFloat(el[mkt2])])
        let ser: Highcharts.SeriesOptionsType[] = [
          { name: mkt1, type: 'line', data: s1, dashStyle: 'ShortDot' },
          { name: mkt2, type: 'line', data: s2, dashStyle: 'ShortDot' },
          { name: 'CrossTrend', type: 'line', data: s1a, dashStyle: 'LongDash', color: 'orange' },
          { name: mkt1+mkt2, type: 'line', data: s3 , yAxis: 4, color: 'lightgreen'},
        ]
        this.chartOptions2 = {
          title: {
            text: 'CrossTrend H4 ' + mkt1 + mkt2
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          yAxis: [
            {
              plotLines: [{
                value: 0,
                width: 2,
                color: 'black'
              },{
                value: 30,
                width: 1,
                color: 'green',
                dashStyle: 'LongDashDot',
                zIndex: 5
              },{
                value: -30,
                width: 1,
                color: 'green',
                dashStyle: 'LongDashDot',
                zIndex: 5
              }, {
                value: 20,
                width: 1,
                color: 'red',
                dashStyle: 'LongDashDot',
                zIndex: 5
              }, {
                value: -20,
                width: 1,
                color: 'red',
                dashStyle: 'LongDashDot',
                zIndex: 5
              }]
            },
            {
              title: {text: mkt1}
            },
            {
              title: {text: mkt2}
            },
            {
              title: { text: 'CrossTrend' },
            },
            {
              title: {text: 'Cambio'},
              opposite: true
            },
          ],
          series: ser
        }
        
        let ser2: Highcharts.SeriesOptionsType[] = [
          { name: 'CrossTrend', type: 'line', data: s1a, color: 'orange' },
          { name: mkt1 + mkt2, type: 'line', data: s3, yAxis: 2, color: 'lightgreen' },
        ]
        this.chartOptions3 = {
          title: {
            text: 'CrossTrend H4 ' + mkt1 + mkt2
          },
          chart: {
            zooming: {
              type: 'x'
            }
          },
          xAxis: {
            //type: 'datetime'
          },
          yAxis: [{
            plotLines: [{
              value: 0,
              width: 2,
              color: 'gray'
            }/* , {
              value: 30,
              width: 1,
              color: 'green',
              dashStyle: 'LongDash',
              zIndex: 5
            }, {
              value: -30,
              width: 1,
              color: 'green',
              dashStyle: 'LongDash',
              zIndex: 5
            }, {
              value: 20,
              width: 1,
              color: 'red',
              dashStyle: 'LongDashDot',
              zIndex: 5
            }, {
              value: -20,
              width: 1,
              color: 'red',
              dashStyle: 'LongDashDot',
              zIndex: 5
            } */]
          },
          {
            title: { text: mkt1 + mkt2 }
          },
          {
            title: { text: 'Cambio' },
            opposite: true
          }
          ],
          series: ser2
        }
      }
    })
  }

}
